import Error from '../../components/Error';

const NotFound = () => {
  return <Error message="Page not found." />;
};

export default NotFound;
